import React from "react";
import logo from "../../../assets/images/chi/Symbol Black_CHI.png";
import TextSlide from "../Slider/text_slide";
const Header = () => {
  return (
    <nav className="">
      <header className="text-slate-700 container relative mx-auto flex flex-col overflow-hidden px-4 py-4 lg:flex-row lg:items-center">
        <a
          href="#"
          className="flex items-center whitespace-nowrap text-2xl font-black"
        >
          <span className="mr-2 w-8">
            <img src={logo} alt="" />
          </span>
          <span>Chi</span>
        </a>
        <input type="checkbox" className="peer hidden" id="navbar-open" />
        <label
          className="absolute top-5 right-5 cursor-pointer lg:hidden"
          for="navbar-open"
        >
          <svg
            className="h-7 w-7"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </label>
        <nav
          aria-label="Header Navigation"
          className="peer-checked:py-4 rounded-md  peer-checked:max-h-60 flex max-h-0 w-full flex-col items-center overflow-hidden transition-all  lg:max-h-full lg:flex-row"
        >
          <ul className="flex w-full flex-col items-center space-y-2 lg:flex-row lg:justify-center lg:space-y-0">
            <li className="lg:mr-12 nav-link !text-base">
              <a
                className="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
                href="/"
              >
                Home
              </a>
            </li>
            <li className="lg:mr-12 nav-link !text-base">
              <a
                className="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
                href="https://chiwellness.pitiplus.app/"
              >
                Shop
              </a>
            </li>
            {/* <li className="lg:mr-12">
              <a
                className="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
                href="#"
              >
                Contact
              </a>
            </li>
            <li className="lg:mr-12">
              <a
                className="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
                href="#"
              >
                FAQ
              </a>
            </li> */}
          </ul>
        </nav>
      </header>
      <header className="bg-[#F2F2F2]">
        <TextSlide />
      </header>
      <header className="bg-[#CCCCCC] text-center px-6 py-3 text-sm titlefont">
        Last Chance: 20% off Glo Skin Beauty. No code needed. SHOP NOW
      </header>
    </nav>
  );
};

export default Header;
